// 9fbef606107a605d69c0edbcd8029e5d
export default {
  TYPE_MODULE: 'module',
  TYPE_NAVIGATION: 'main-navigation',
  TYPE_LABELS: 'labels',
  TYPE_ACCOUNT_NAVIGATION: 'account-navigation',
  TYPE_SITEMAP: 'sitemap',
  TYPE_STORE_DETAILS: 'store-details',
  TYPE_SUB_NAVIGATION: 'sub-navigation',
  TYPE_HEADER: 'header',
  TYPE_FOOTER: 'footer',
  TYPE_LAYOUT: 'layout',
  TYPE_CONTENT_LAYOUT: 'content-layout',
  TYPE_SEO_DATA: 'seo-data',
  TYPE_XAPP_CONFIG: 'xapp-config',
  TYPE_COUNTRY_LIST: 'country-list',
  TYPE_LAST_UPDATED: 'last-updated',
  TYPE_SITE_CONFIG: 'site-configuration',
  TYPE_PROMO_COMBINATION: 'promo-combination',
};

export const crossBrands = ['TCP', 'Gymboree'];

export const crossBrandedKeys = [
  'BOPIS_ENABLED',
  'BOPIS_ENABLED_CLEARANCE_PRODUCTS',
  'BOSS_ENABLED_APP',
  'BOSS_ENABLED_CLEARANCE_PRODUCTS',
  'IS_BOSS_ENABLED',
  'IS_RADIAL_BOSS_ENABLED',
  'KEEPALIVE_PRODUCTFLAG',
  'KEEPALIVE_PRODUCTFLAG_APP',
];
